import { render } from "./destination-table.vue?vue&type=template&id=a8b134f0"
import script from "./destination-table.vue?vue&type=script&lang=js"
export * from "./destination-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__